'use es6';

const getBasicBounds = element => {
  if (element) {
    const bounds = element.getBoundingClientRect();
    const isHiddenElement = bounds.width === 0 && bounds.height === 0 && bounds.left === 0 && bounds.right === 0;
    return {
      bottom: bounds.bottom,
      hasBounds: !isHiddenElement,
      height: bounds.height,
      left: bounds.left,
      right: bounds.right,
      top: bounds.top,
      width: bounds.width
    };
  }
  return {
    hasBounds: false
  };
};
const applyPositionInfoToBounds = (bounds, element) => {
  if (element && bounds.hasBounds) {
    const computedStyles = window.getComputedStyle(element);
    const computedPosition = computedStyles.position;
    bounds.isFixedPosition = computedPosition === 'fixed';
    bounds.isAbsolutePosition = computedPosition === 'absolute';
  }
};
const applyScrollOffsetToBounds = bounds => {
  if (bounds.hasBounds) {
    const yOffset = bounds.isFixedPosition ? 0 : window.pageYOffset;
    const xOffset = bounds.isFixedPosition ? 0 : window.pageXOffset;
    bounds.bottom += yOffset;
    bounds.left += xOffset;
    bounds.right += xOffset;
    bounds.top += yOffset;
  }
};
const applyElementScrollOffsetToBounds = (bounds, element) => {
  if (!bounds.hasBounds || !element) {
    return;
  }
  const yOffset = bounds.isFixedPosition ? element.scrollTop - bounds.top : element.scrollTop;
  const xOffset = bounds.isFixedPosition ? element.scrollLeft - bounds.left : element.scrollLeft;
  bounds.top += yOffset;
  bounds.bottom += yOffset;
  bounds.left += xOffset;
  bounds.right += xOffset;
};
const applyOffsetToBounds = (bounds, element) => {
  if (!bounds.hasBounds || !element) {
    return;
  }
  bounds.offsetTop = element.offsetTop;
  bounds.offsetBottom = bounds.offsetTop + bounds.height;
  bounds.offsetLeft = element.offsetLeft;
  bounds.offsetRight = bounds.offsetLeft + bounds.width;
  bounds.hasOffset = true;
};
export const getElementBounds = (element, {
  applyPositionInfo = false,
  applyScrollOffset = false,
  applyElementScrollOffset = false,
  applyOffset = false
} = {}) => {
  const bounds = getBasicBounds(element);
  if (applyPositionInfo) {
    applyPositionInfoToBounds(bounds, element);
  }
  if (applyScrollOffset) {
    applyScrollOffsetToBounds(bounds);
  }
  if (applyElementScrollOffset) {
    applyElementScrollOffsetToBounds(bounds, element);
  }
  if (applyOffset) {
    applyOffsetToBounds(bounds, element);
  }
  return bounds;
};
export const buildGetElementBounds = (config = {}) => element => getElementBounds(element, config);
export const getCurrentViewportBounds = () => {
  return {
    top: window.pageYOffset,
    bottom: window.pageYOffset + window.innerHeight,
    left: window.pageXOffset,
    right: window.pageXOffset + window.innerWidth
  };
};